import type { ServiceHook } from './interface'

const useQueryString: ServiceHook<URLSearchParams> = () => new URLSearchParams(window.location.search)

export default useQueryString
